import {zDateTime, zNumberToString} from '@brunata-angular/util';
import {z} from 'zod';

export const meterEventSchema = z
    .object({
        propertyNo: z.string().nullable(),
        branchNo: z.string().nullable(),
        locationNo: z.string().nullable(),
        address: z.string().nullable(),
        meterSuperType: zNumberToString,
        alloUnitType: z.string(),
        meterNo: z.string(),
        meterModel: z.string(),
        dismountedDate: zDateTime.nullable(),
        meterPlacement: z.string().nullable(),
        severity: z.string(),
        eventType: z.string(),
        categoryName: z.string(),
        action: z.string().nullable(),
        createdDate: zDateTime,
        mountingDate: zDateTime.nullable(),
        printedSerialNo: z.string().nullable(),
    })
    .transform(data => ({
        ...data,
        proBraLoc: `${data.propertyNo ?? ''}-${data.branchNo ?? ''}-${data.locationNo ?? ''}`,
    }));

export type MeterEvent = z.infer<typeof meterEventSchema>;
